"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.view = void 0;
var csod = require("player-core");
var UrlHelper_1 = require("../../shared/code/UrlHelper");
function view(props) {
    var _this = this;
    return {
        state: {
            isLoginDialogVisible: false,
            hideIsolationBar: props.hideIsolationBar,
            contentPaddingBottom: "Medium",
            linkedInIframeContent: ""
        },
        initialize: function () {
            return new Promise(function (resolve) {
                resolve();
            });
        },
        mounted: function () {
        },
        unmount: function () {
        },
        receivedProps: function (nextProps) { return new Promise(function (resolve) {
            if (nextProps.currentPage > nextProps.totalPages) {
                _this.view.state.hideIsolationBar = true;
                _this.view.state.contentPaddingBottom = "Xlarge";
            }
            resolve();
        }); },
        events: {
            onBack: function () {
                props.onBack && props.onBack();
            },
            onNext: function () {
                props.onNext && props.onNext();
            },
            onSubmit: function () {
                props.onSubmit && props.onSubmit();
            },
            onCancel: function () {
                props.onCancel && props.onCancel();
            },
            onLoginDialogClose: function () {
                if (_this.view.state.linkedInIframeContent) {
                    var linkedInIframe = document.querySelector('.p-awliwidget');
                    linkedInIframe.innerHTML = _this.view.state.linkedInIframeContent;
                }
                document.querySelector('#cs-root').removeAttribute('aria-hidden');
                _this.view.state.isLoginDialogVisible = false;
            },
            onSave: function () {
                if (csod.context.user > 0) {
                    props.onSave && props.onSave();
                }
                else {
                    var linkedInIframe = document.querySelector('.p-awliwidget');
                    if (linkedInIframe) {
                        this.view.state.linkedInIframeContent = linkedInIframe.innerHTML;
                        linkedInIframe.innerHTML = "";
                    }
                    document.querySelector('#cs-root').setAttribute('aria-hidden', 'true');
                    this.view.state.isLoginDialogVisible = true;
                }
            },
            onSignInClick: function () {
                window.sessionStorage.setItem(csod.viewModel.resultDataLocalStorageKey, JSON.stringify({
                    resultData: csod.viewModel.resultData,
                    saveOnReload: true,
                    currentPage: csod.viewModel.workflowPage.currentPage,
                }));
                var contactInfo = csod.viewModel.resultData.find(function (x) { return x.type === 'contactInformation'; });
                var queryString = UrlHelper_1.UrlHelper.buildQueryString({
                    fn: contactInfo.firstName,
                    ln: contactInfo.lastName,
                    email: contactInfo.email,
                    returnurl: "" + window.location.pathname + window.location.search,
                    lang: csod.viewModel.cultureName,
                    site: csod.viewModel.careerSiteId
                });
                var loginUrl = csod.context.applicationBase + "ats/careersite/login.aspx?" + queryString;
                window.location.replace(loginUrl);
            },
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationWorkflowTemplate/View.js
// module id = 597
// module chunks = 0